import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { InvestmentSectorAllocationModel } from '../../Models/Models/PortfolioAnalysis/Investment/InvestmentSectorAllocationModel';
import { AssetClassType } from '../../Constants/Enums/Domain/Instrument/AssetClassType';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class InvestmentSectorAllocationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyIds: Array<string>, assetClassType: AssetClassType, asAt: IJsonDate): Promise<InvestmentSectorAllocationModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioValuation/InvestmentSectorAllocation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds, assetClassType: assetClassType, asAt: asAt }

    return AjaxWrapper.get<InvestmentSectorAllocationModel, any>(url, data);
  }
}

